/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';
import { ValidationService } from '../../../../../core/services';

@Directive({
    selector: '[appHostnameValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: GlobalNamesDomainValidationDirective, multi: true }]
})

export class GlobalNamesDomainValidationDirective implements Validator {
    public validate(control: AbstractControl): { [key: string]: any } | null {
        return globalNamesDomainValidation(control);
    }
}

/**
 * Global names domain validation.
 * @param control
 * @returns {any}
 */
export function globalNamesDomainValidation(control: any): any {
    return (
        !control?.value ||
        ValidationService.fqdnCheck(control?.value) ||
        ValidationService.domainNameCheck(control?.value)

    ) ? null : {
        'globalNameDomainValidation': 'domain_validation_error'
    };

}
